/* Auto-synced from permission catalog API — 166 permissions */
const SUBUSER_PERMISSION_SLUGS = {
  AUDITOR_ACTIVITY_LOGS_VIEW: 'reports.orders.view',
  AUDITOR_DASHBOARD: 'general.statistics.view',
  AUDITOR_STATISTICS_VIEW: 'reports.statistics.view',
  B2B_CREDIT_LIMIT: 'b2b.credit.limit',
  B2B_CREDIT_LIMIT_HISTORY: 'b2b.credit.limit_history',
  B2B_CREDIT_SETTLE: 'b2b.credit.settle',
  B2B_CREDIT_SETTLEMENT_HISTORY: 'b2b.credit.settlement_history',
  B2B_DELETE: 'b2b.delete',
  B2B_MANAGE: 'b2b.manage',
  B2B_VIEW: 'b2b.view',
  ANNOUNCEMENT_BARS_DELETE: 'marketing.announcement_bars.delete',
  ANNOUNCEMENT_BARS_MANAGE: 'marketing.announcement_bars.manage',
  ANNOUNCEMENT_BARS_VIEW: 'marketing.announcement_bars.view',
  BANNERS_DELETE: 'banners.delete',
  BANNERS_MANAGE: 'banners.manage',
  BANNERS_VIEW: 'banners.view',
  BRANCHES_DELETE: 'branches.delete',
  BRANCHES_MANAGE: 'branches.manage',
  BRANCHES_RECEIPT_MANAGE: 'branches.receipt.manage',
  BRANCHES_SETTINGS_MANAGE: 'branches.settings.manage',
  BRANCHES_SETTINGS_VIEW: 'branches.settings.view',
  CAMPAIGNS_MANAGE: 'marketing.campaigns.manage',
  CAMPAIGNS_VIEW: 'marketing.campaigns.view',
  CLIENTS_EXPORT: 'clients.export',
  CLIENTS_MANAGE: 'clients.manage',
  CLIENTS_VIEW: 'clients.view',
  COUPONS_DELETE: 'coupons.delete',
  COUPONS_MANAGE: 'coupons.manage',
  COUPONS_VIEW: 'coupons.view',
  CUSTOMER_TAGS_MANAGE: 'settings.tags.manage',
  DASHBOARD_API_MANAGE: 'dashboard_api.manage',
  DASHBOARD_API_VIEW: 'dashboard_api.view',
  DISCOUNTS_DELETE: 'discounts.delete',
  DISCOUNTS_MANAGE: 'discounts.manage',
  DISCOUNTS_VIEW: 'discounts.view',
  DISPLAY_DEVICES_DELETE: 'display_devices.delete',
  DISPLAY_DEVICES_MANAGE: 'display_devices.manage',
  DISPLAY_DEVICES_VIEW: 'display_devices.view',
  GENERAL_DEVICES_MANAGE: 'general.devices.manage',
  GENERAL_DEVICES_VIEW: 'general.devices.view',
  GENERAL_FEEDBACK_SEND: 'general.feedback.send',
  GENERAL_POLICIES_MANAGE: 'settings.policies.manage',
  GENERAL_QR_MANAGE: 'branches.settings.manage',
  GENERAL_STATISTICS_VIEW: 'general.statistics.view',
  INTEGRATIONS_CONNECTIONS_MANAGE: 'integrations.view',
  INTEGRATIONS_POS_SYNC: 'integrations.view',
  INTEGRATIONS_VIEW: 'integrations.view',
  INVENTORY_COUNTS_MANAGE: 'inventory.counts.manage',
  INVENTORY_COUNTS_SUBMIT: 'inventory.counts.submit',
  INVENTORY_COUNTS_VIEW: 'inventory.counts.view',
  INVENTORY_INGREDIENTS_DELETE: 'inventory.ingredients.delete',
  INVENTORY_INGREDIENTS_MANAGE: 'inventory.ingredients.manage',
  INVENTORY_INGREDIENTS_VIEW: 'inventory.ingredients.view',
  INVENTORY_ITEMS_MANAGE: 'inventory.items.manage',
  INVENTORY_ITEMS_VIEW: 'inventory.items.view',
  INVENTORY_RECIPES_DELETE: 'inventory.recipes.delete',
  INVENTORY_RECIPES_MANAGE: 'inventory.recipes.manage',
  INVENTORY_RECIPES_VIEW: 'inventory.recipes.view',
  INVENTORY_SPOT_CHECKS_MANAGE: 'inventory.spot_checks.manage',
  INVENTORY_SPOT_CHECKS_SUBMIT: 'inventory.spot_checks.submit',
  INVENTORY_SPOT_CHECKS_VIEW: 'inventory.spot_checks.view',
  INVENTORY_STOCK_REPORT_VIEW: 'inventory.stock_report.view',
  INVENTORY_STOCK_VIEW: 'inventory.stock.view',
  INVENTORY_SUPPLIERS_DELETE: 'inventory.suppliers.delete',
  INVENTORY_SUPPLIERS_MANAGE: 'inventory.suppliers.manage',
  INVENTORY_SUPPLIERS_VIEW: 'inventory.suppliers.view',
  INVENTORY_TRANSACTIONS_DELETE: 'inventory.transactions.delete',
  INVENTORY_TRANSACTIONS_MANAGE: 'inventory.transactions.manage',
  INVENTORY_TRANSACTIONS_VIEW: 'inventory.transactions.view',
  INVENTORY_UNITS_DELETE: 'inventory.units.delete',
  INVENTORY_UNITS_MANAGE: 'inventory.units.manage',
  INVENTORY_UNITS_VIEW: 'inventory.units.view',
  KITCHEN_ACCESS: 'kitchen.access',
  KITCHEN_ORDERS_PUSH: 'kitchen.orders.push',
  KITCHEN_SETTINGS_MANAGE: 'kitchen.settings.manage',
  MARKETING_ACCESS: 'marketing.access',
  MARKETING_CAMPAIGNS_DELETE: 'marketing.campaigns.delete',
  MARKETING_CAMPAIGNS_MANAGE: 'marketing.campaigns.manage',
  MARKETING_CAMPAIGNS_VIEW: 'marketing.campaigns.view',
  MARKETING_EVENTS_MANAGE: 'marketing.events.manage',
  MARKETING_EVENTS_VIEW: 'marketing.events.view',
  MARKETING_TAGS_MANAGE: 'settings.tags.manage',
  MARKETING_TIERS_MANAGE: 'settings.tiers.manage',
  MARKETING_WALLETS_DELETE: 'marketing.wallets.delete',
  MARKETING_WALLETS_MANAGE: 'marketing.wallets.manage',
  MEDIA_MANAGE: 'media.manage',
  MEDIA_UPLOAD: 'media.upload',
  MEDIA_VIEW: 'media.view',
  MENU_BULK_MANAGE: 'menu.bulk.manage',
  MENU_BULK_VIEW: 'menu.bulk.view',
  MENU_CATEGORIES_DELETE: 'menu.categories.delete',
  MENU_CATEGORIES_MANAGE: 'menu.categories.manage',
  MENU_CATEGORY_DELETE: 'menu.categories.delete',
  MENU_DELETE: 'menu.items.delete',
  MENU_ITEMS_DELETE: 'menu.items.delete',
  MENU_ITEMS_MANAGE: 'menu.items.manage',
  MENU_ITEMS_VIEW: 'menu.items.view',
  MENU_MANAGE: 'menu.items.manage',
  MENU_SYNC: 'menu.items.manage',
  MENU_VIEW: 'menu.items.view',
  MODIFIERS_DELETE: 'modifiers.delete',
  MODIFIERS_MANAGE: 'modifiers.manage',
  MODIFIERS_VIEW: 'modifiers.view',
  CUSTOM_INPUTS_MANAGE: 'custom_inputs.manage',
  CUSTOM_INPUTS_VIEW: 'custom_inputs.view',
  CUSTOM_INPUTS_DELETE: 'custom_inputs.delete',
  NEWSLETTER_MANAGE: 'newsletter.manage',
  NEWSLETTER_VIEW: 'newsletter.view',
  NEWSLETTERS_MANAGE: 'newsletter.manage',
  NEWSLETTERS_VIEW: 'newsletter.view',
  NOTIFICATIONS_DELETE: 'notifications.delete',
  NOTIFICATIONS_MANAGE: 'notifications.manage',
  NOTIFICATIONS_VIEW: 'notifications.view',
  ODS_BUSY: 'ods.branch.busy',
  ODS_MANAGE: 'ods.orders.update',
  ODS_VIEW: 'ods.orders.view',
  ORDER_DISPLAY_ACCESS: 'order_display.view',
  ORDER_DISPLAY_MANAGE: 'order_display.manage',
  ORDER_DISPLAY_VIEW: 'order_display.view',
  ORDERS_ABANDONED_MANAGE: 'orders.abandoned.manage',
  ORDERS_ABANDONED_VIEW: 'orders.abandoned.view',
  ORDERS_EXPORT: 'orders.export',
  ORDERS_MANAGE: 'orders.manage',
  ORDERS_NOTIFICATIONS_VIEW: 'orders.notifications.view',
  ORDERS_PAYMENT_CREATE: 'orders.payment.create',
  ORDERS_REFUND: 'orders.refund',
  ORDERS_RESERVATION_ORDERS_MANAGE: 'orders.reservation_orders.manage',
  ORDERS_RESERVATION_ORDERS_VIEW: 'orders.reservation_orders.view',
  ORDERS_RETURN_ORDERS_VIEW: 'orders.return_orders.view',
  ORDERS_TRANSFER_EXECUTE: 'orders.transfer.manage',
  ORDERS_TRANSFER_MANAGE: 'orders.transfer.manage',
  ORDERS_TRANSFER_VALIDATE: 'orders.transfer.manage',
  ORDERS_VIEW: 'orders.view',
  PAYMENT_LINKS_MANAGE: 'payment_links.manage',
  PAYMENT_LINKS_VIEW: 'payment_links.view',
  POS_ACCESS: 'pos.preview.view',
  POS_FLOORS_MANAGE: 'pos.settings.manage',
  POS_ORDERS_PLACE: 'pos.preview.view',
  POS_PAYMENT_METHODS_DELETE: 'pos.payment_methods.delete',
  POS_PAYMENT_METHODS_MANAGE: 'pos.payment_methods.manage',
  POS_PAYMENT_METHODS_VIEW: 'pos.payment_methods.view',
  POS_PREVIEW_VIEW: 'pos.preview.view',
  POS_RETURN_ORDERS_MANAGE: 'pos.return_orders.manage',
  POS_RETURN_REASONS_DELETE: 'pos.return_reasons.delete',
  POS_RETURN_REASONS_MANAGE: 'pos.return_reasons.manage',
  POS_RETURN_REASONS_VIEW: 'pos.return_reasons.view',
  POS_SESSIONS_MANAGE: 'pos.sessions.manage',
  POS_SESSIONS_VIEW: 'pos.sessions.view',
  POS_SETTINGS_MANAGE: 'pos.settings.manage',
  POS_SETTINGS_VIEW: 'pos.settings.view',
  POS_TERMINALS_DELETE: 'pos.terminals.delete',
  POS_TERMINALS_MANAGE: 'pos.terminals.manage',
  POS_TERMINALS_VIEW: 'pos.terminals.view',
  PROMOTIONS_ACCESS: 'promotions.view',
  PROMOTIONS_DELETE: 'promotions.delete',
  PROMOTIONS_MANAGE: 'promotions.manage',
  PROMOTIONS_VIEW: 'promotions.view',
  QUEUES_MANAGE: 'queues.manage',
  QUEUES_VIEW: 'queues.view',
  REPORTS_BRANCHES_STATISTICS_VIEW: 'reports.branches_statistics.view',
  REPORTS_EXPORT: 'orders.export',
  REPORTS_GAIN_AND_LOSS_VIEW: 'reports.gain_and_loss.view',
  REPORTS_INVENTORY_VIEW: 'inventory.stock_report.view',
  REPORTS_ORDER_LINES_VIEW: 'reports.order_lines.view',
  REPORTS_ORDERS_VIEW: 'reports.orders.view',
  REPORTS_POS_SESSIONS_VIEW: 'reports.orders.view',
  REPORTS_SALES_PER_VIEW: 'reports.sales_per.view',
  REPORTS_SALES_VIEW: 'reports.sales.view',
  REPORTS_STATISTICS_VIEW: 'reports.statistics.view',
  REPORTS_TRANSFERABLE_ORDERS_VIEW: 'reports.transferable_orders.view',
  REPORTS_VIEW: 'reports.statistics.view',
  RESERVATIONS_MANAGE: 'reservations.manage',
  RESERVATIONS_VIEW: 'reservations.view',
  REVIEWS_MANAGE: 'reviews.manage',
  REVIEWS_VIEW: 'reviews.view',
  ROLES_ASSIGN: 'roles.assign',
  ROLES_MANAGE: 'roles.manage',
  ROLES_VIEW: 'roles.view',
  SETTINGS_ACCESS: 'branches.settings.view',
  SETTINGS_AGE_GROUPS_DELETE: 'settings.age_groups.delete',
  SETTINGS_AGE_GROUPS_MANAGE: 'settings.age_groups.manage',
  SETTINGS_AGE_GROUPS_VIEW: 'settings.age_groups.view',
  SETTINGS_BUSINESS_INFO_MANAGE: 'settings.business_info.manage',
  SETTINGS_BUSINESS_INFO_VIEW: 'settings.business_info.view',
  SETTINGS_BUSINESS_SETTINGS_MANAGE: 'settings.business_settings.manage',
  SETTINGS_BUSINESS_SETTINGS_VIEW: 'settings.business_settings.view',
  SETTINGS_CANCEL_REASONS_DELETE: 'settings.cancel_reasons.delete',
  SETTINGS_CANCEL_REASONS_MANAGE: 'settings.cancel_reasons.manage',
  SETTINGS_CANCEL_REASONS_VIEW: 'settings.cancel_reasons.view',
  SETTINGS_EMAIL_REPORTS_DELETE: 'settings.email_reports.delete',
  SETTINGS_EMAIL_REPORTS_MANAGE: 'settings.email_reports.manage',
  SETTINGS_EMAIL_REPORTS_VIEW: 'settings.email_reports.view',
  SETTINGS_LOCALIZATIONS_MANAGE: 'settings.localizations.manage',
  SETTINGS_LOCALIZATIONS_VIEW: 'settings.localizations.view',
  SETTINGS_POLICIES_DELETE: 'settings.policies.delete',
  SETTINGS_POLICIES_MANAGE: 'settings.policies.manage',
  SETTINGS_POLICIES_VIEW: 'settings.policies.view',
  SETTINGS_SOCIAL_LINKS_MANAGE: 'settings.social_links.manage',
  SETTINGS_SOCIAL_LINKS_VIEW: 'settings.social_links.view',
  SETTINGS_TAGS_MANAGE: 'settings.tags.manage',
  SETTINGS_TAGS_VIEW: 'settings.tags.view',
  SETTINGS_THEMES_MANAGE: 'themes.manage',
  SETTINGS_TIERS_MANAGE: 'settings.tiers.manage',
  SETTINGS_TIERS_VIEW: 'settings.tiers.view',
  SETTINGS_WHATSAPP_REPORTS_DELETE: 'settings.whatsapp_reports.delete',
  SETTINGS_WHATSAPP_REPORTS_MANAGE: 'settings.whatsapp_reports.manage',
  SETTINGS_WHATSAPP_REPORTS_VIEW: 'settings.whatsapp_reports.view',
  SUBUSERS_DELETE: 'subusers.delete',
  SUBUSERS_MANAGE: 'subusers.manage',
  SUBUSERS_VIEW: 'subusers.view',
  SURVEYS_DELETE: 'surveys.delete',
  SURVEYS_MANAGE: 'surveys.manage',
  SURVEYS_VIEW: 'surveys.view',
  TAX_GROUPS_DELETE: 'tax_groups.delete',
  TAX_GROUPS_MANAGE: 'tax_groups.manage',
  TAX_GROUPS_VIEW: 'tax_groups.view',
  TAXES_DELETE: 'taxes.delete',
  TAXES_MANAGE: 'taxes.manage',
  TAXES_VIEW: 'taxes.view',
  THEMES_MANAGE: 'themes.manage',
  TIERS_MANAGE: 'settings.tiers.manage',
  TOOLS_ACCESS: 'marketing.access',
  TRANSACTIONS_MANAGE: 'transactions.manage',
  TRANSACTIONS_VIEW: 'transactions.view',
  WALLETS_DELETE: 'marketing.wallets.delete',
  WALLETS_MANAGE: 'marketing.wallets.manage',
} as const

/** Normalize legacy FE slugs to backend catalog slugs */
const LEGACY_SLUG_TO_CANONICAL: Record<string, string> = {
  'ods.view': 'ods.orders.view',
  'ods.manage': 'ods.orders.update',
  'ods.busy': 'ods.branch.busy',
  'newsletters.view': 'newsletter.view',
  'newsletters.manage': 'newsletter.manage',
  'campaigns.view': 'marketing.campaigns.view',
  'campaigns.manage': 'marketing.campaigns.manage',
  'wallets.manage': 'marketing.wallets.manage',
  'customer_tags.manage': 'marketing.tags.manage',
  'tiers.manage': 'marketing.tiers.manage',
  'marketing_events.manage': 'marketing.events.manage',
  'settings.themes.manage': 'themes.manage',
  'auditor.dashboard': 'general.statistics.view',
  'menu.view': 'menu.items.view',
  'menu.manage': 'menu.items.manage',
  'pos.access': 'pos.preview.view',
  'integrations.connections.manage': 'integrations.view',
  'order_display.access': 'order_display.view',
}

export function canonicalizePermissionSlug(slug: string): string {
  if (!slug) return slug
  return LEGACY_SLUG_TO_CANONICAL[slug] ?? slug
}

export function expandPermissionSlug(slug: string): string[] {
  if (!slug) return []
  const canonical = canonicalizePermissionSlug(slug)
  return canonical === slug ? [canonical] : [canonical, slug]
}

export function matchesSubuserPermission(userPermissions: Array<string>, required: string): boolean {
  if (!required) return false
  const requiredSlug = canonicalizePermissionSlug(required)
  return (userPermissions || [])
    .map(permission => (typeof permission === 'string' ? canonicalizePermissionSlug(permission) : null))
    .filter(Boolean)
    .includes(requiredSlug)
}

/** Overrides where slug-based i18n key differs from the permission display name key */
const PERMISSION_SLUG_I18N_OVERRIDES: Record<string, string> = {
  'auditor.dashboard.access': 'auditor_dashboard',
  'menu.items.view': 'view_menu_items',
  'menu.items.manage': 'manage_menu_items',
  'menu.items.delete': 'delete_menu_items',
  'menu.categories.delete': 'delete_categories',
  'menu.categories.manage': 'manage_categories',
  'subusers.delete': 'delete_subusers',
  'newsletter.view': 'newsletters_view',
  'newsletter.manage': 'newsletters_manage',
  'marketing.campaigns.view': 'campaigns_view',
  'marketing.campaigns.manage': 'campaigns_manage',
  'marketing.wallets.manage': 'wallets_manage',
  'marketing.tags.manage': 'customer_tags_manage',
  'marketing.tiers.manage': 'tiers_manage',
  'marketing.events.manage': 'marketing_events_manage',
  'orders.notifications.view': 'orders_notifications_view',
  'inventory.transactions.view': 'inventory_transactions_view',
  'inventory.transactions.manage': 'inventory_transactions_manage',
  'transactions.view': 'transactions_view',
  'transactions.manage': 'transactions_manage',
  'integrations.view': 'view_integrations',
  'kitchen.settings.manage': 'kitchen_settings',
  'kitchen.orders.push': 'push_kitchen_orders',
  'ods.orders.view': 'view_delivery_orders',
  'ods.orders.update': 'update_delivery_status',
  'ods.branch.busy': 'set_branch_busy',
  'pos.preview.view': 'pos_preview_access',
  'pos.sessions.manage': 'manage_pos_sessions',
  'pos.terminals.manage': 'manage_pos_terminals',
  'pos.settings.manage': 'pos_settings',
  'pos.payment_methods.manage': 'manage_payment_methods',
  'pos.return_orders.manage': 'manage_return_orders',
  'reports.sales.view': 'sales_report',
  'reports.orders.view': 'order_reports',
  'reports.gain_and_loss.view': 'gain_and_loss',
  'reports.sales_per.view': 'sales_per',
  'reports.order_lines.view': 'order_lines',
  'reports.transferable_orders.view': 'transferable_orders',
  'reports.statistics.view': 'statistics',
  'reports.branches_statistics.view': 'branches_statistics',
  'themes.manage': 'settings_themes_manage',
  'general.devices.manage': 'general_devices_manage',
  'payment_links.view': 'payment_links_view',
  'queues.view': 'view_queue',
  'queues.manage': 'manage_queue',
  'discounts.view': 'discounts_view',
  'discounts.manage': 'discounts_manage',
  'coupons.view': 'coupons_view',
  'coupons.manage': 'coupons_manage',
  'promotions.view': 'view_promotions',
  'branches.delete': 'branches_delete',
  'pos.return_reasons.view': 'view_return_reasons',
  'pos.return_reasons.manage': 'manage_return_reasons',
  'pos.return_reasons.delete': 'delete_return_reasons',
  'settings.business_info.view': 'view_business_information',
  'settings.business_info.manage': 'manage_business_information',
  'settings.business_settings.view': 'view_business_settings',
  'settings.business_settings.manage': 'manage_business_settings',
  'settings.cancel_reasons.view': 'view_cancel_reasons',
  'settings.cancel_reasons.manage': 'manage_cancel_reasons',
  'settings.cancel_reasons.delete': 'delete_cancel_reasons',
  'settings.social_links.view': 'view_social_links',
  'settings.social_links.manage': 'manage_social_links',
  'settings.whatsapp_reports.view': 'view_whatsapp_reports',
  'settings.whatsapp_reports.manage': 'manage_whatsapp_reports',
  'settings.whatsapp_reports.delete': 'delete_whatsapp_reports',
  'settings.email_reports.view': 'view_email_reports',
  'settings.email_reports.manage': 'manage_email_reports',
  'settings.email_reports.delete': 'delete_email_reports',
  'settings.policies.view': 'view_policies',
  'settings.policies.manage': 'manage_policies',
  'settings.policies.delete': 'delete_policies',
  'settings.tiers.view': 'view_tiers_setup',
  'settings.tiers.manage': 'manage_tiers_setup',
  'settings.tags.view': 'view_tags_setup',
  'settings.tags.manage': 'manage_tags_setup',
  'settings.age_groups.view': 'view_age_group_setup',
  'settings.age_groups.manage': 'manage_age_group_setup',
  'settings.age_groups.delete': 'delete_age_group_setup',
  'banners.view': 'view_banners',
  'marketing.announcement_bars.view': 'announcement_bars_view',
  'marketing.announcement_bars.manage': 'announcement_bars_manage',
  'marketing.announcement_bars.delete': 'announcement_bars_delete',
  'marketing.campaigns.delete': 'delete_campaigns',
  'order_display.view': 'order_display_view',
  'order_display.manage': 'order_display_manage',
}

const PERMISSION_SLUG_I18N_KEYS: Record<string, string> = {
  ...PERMISSION_SLUG_I18N_OVERRIDES,
}

/** i18n key under roles.permissions.* for a canonical permission slug */
export function permissionSlugToI18nKey(slug: string): string {
  if (!slug) return slug
  const canonical = canonicalizePermissionSlug(slug)
  return PERMISSION_SLUG_I18N_KEYS[canonical] ?? canonical.replace(/\./g, '_')
}

export function getPermissionSlug(permission?: {
  slug?: string;
} | null): string | null {
  if (!permission?.slug) return null
  return canonicalizePermissionSlug(permission.slug)
}

/** Sort order: view/access → manage/actions → delete */
const PERMISSION_ACTION_SORT_ORDER: Record<string, number> = {
  view: 1,
  access: 1,
  manage: 2,
  submit: 2,
  export: 2,
  assign: 2,
  refund: 2,
  push: 2,
  sync: 2,
  busy: 2,
  update: 2,
  execute: 2,
  validate: 2,
  create: 2,
  place: 2,
  upload: 2,
  delete: 3,
}

export function getPermissionActionSortOrder(permission?: { slug?: string; name?: string; id?: number } | null): number {
  if (!permission) return 99

  const slug = (permission.slug ?? getPermissionSlug(permission) ?? '').toLowerCase()
  const name = (permission.name ?? '').toLowerCase().trim()
  const action = slug.includes('.') ? slug.split('.').pop() ?? '' : ''

  if (PERMISSION_ACTION_SORT_ORDER[action] != null) {
    return PERMISSION_ACTION_SORT_ORDER[action]
  }

  if (/^view\b/.test(name) || name.includes(' view')) return 1
  if (/^delete\b/.test(name)) return 3
  if (/^manage\b|^upload\b|^submit\b|^export\b|^assign\b|^refund\b/.test(name)) return 2

  return 2
}

export function comparePermissionCatalogItems(a: any, b: any): number {
  const orderDiff = getPermissionActionSortOrder(a) - getPermissionActionSortOrder(b)
  if (orderDiff !== 0) return orderDiff
  return (a.name ?? '').localeCompare(b.name ?? '') || (a.id ?? 0) - (b.id ?? 0)
}

/** Flatten nested catalog { Group: { Object: Permission[] } } */
export function flattenPermissionCatalog(catalog: Record<string, any> = {}): Array<{
  id: number;
  slug: string;
  name: string;
  group: string;
  object: string;
}> {
  const list: any[] = []
  Object.entries(catalog || {}).forEach(([groupKey, sections]) => {
    if (!sections || typeof sections !== 'object' || Array.isArray(sections)) return
    Object.entries(sections).forEach(([objectKey, items]) => {
      if (!Array.isArray(items)) return
      items.forEach(item => {
        if (!item?.slug && !item?.id) return
        list.push({
          ...item,
          group: item.group ?? groupKey,
          object: item.object ?? objectKey,
        })
      })
    })
  })
  return list
}

function isPermissionRecord(item: any): boolean {
  return !!item && typeof item === 'object' && item.id != null && (item.slug || item.name)
}

function isFlatPermissionList(value: any): boolean {
  return Array.isArray(value) && value.length > 0 && value.every(isPermissionRecord)
}

function isNestedPermissionCatalog(value: any): boolean {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  return Object.values(value).some(section => {
    if (section == null || typeof section !== 'object' || Array.isArray(section)) return false
    return Object.values(section as Record<string, unknown>).some(
      items => Array.isArray(items) && items.some(isPermissionRecord),
    )
  })
}

/** Build nested { Group: { Object: Permission[] } } from flat permission list */
export function nestPermissionCatalog(list: any[] = []): Record<string, Record<string, any[]>> {
  const catalog: Record<string, Record<string, any[]>> = {}
  const seen = new Set<number>()

  list.forEach(item => {
    if (!isPermissionRecord(item) || seen.has(item.id)) return
    seen.add(item.id)

    const group = item.group ?? 'General'
    const object = item.object ?? 'Permissions'
    if (!catalog[group]) catalog[group] = {}
    if (!catalog[group][object]) catalog[group][object] = []
    catalog[group][object].push(item)
  })

  Object.values(catalog).forEach(sections => {
    Object.values(sections).forEach(items => {
      items.sort(comparePermissionCatalogItems)
    })
  })

  return catalog
}

function unwrapPermissionPayload(payload: any): any {
  if (!payload || typeof payload !== 'object') return payload
  if (Array.isArray(payload)) return payload

  if (payload.data && typeof payload.data === 'object') {
    return unwrapPermissionPayload(payload.data)
  }
  if (payload.result && typeof payload.result === 'object') {
    return unwrapPermissionPayload(payload.result)
  }
  return payload
}

/** Normalize API response into nested catalog for role modal / permission pickers */
export function normalizePermissionCatalogResponse(payload: any = {}): Record<string, Record<string, any[]>> {
  const unwrapped = unwrapPermissionPayload(payload)
  if (!unwrapped) return {}

  if (unwrapped.permissions !== undefined) {
    const nested = normalizePermissionCatalogResponse(unwrapped.permissions)
    if (Object.keys(nested).length) return nested
  }

  if (isFlatPermissionList(unwrapped)) {
    return nestPermissionCatalog(unwrapped)
  }

  if (isNestedPermissionCatalog(unwrapped)) {
    return nestPermissionCatalog(flattenPermissionCatalog(unwrapped))
  }

  if (typeof unwrapped === 'object' && !Array.isArray(unwrapped)) {
    const values = Object.values(unwrapped)
    if (values.every(isPermissionRecord)) {
      return nestPermissionCatalog(unwrapped as any[])
    }
  }

  return {}
}

export default SUBUSER_PERMISSION_SLUGS
